import Vue from 'vue'
import Router from 'vue-router'
import user_list from '../views/user/user-list'
import user_item from '../views/user/user-item'
import user_check from '../views/user/user-check'
import userDetail from '../views/user/user-detail'
import resumeList from '../views/user/resume-list'
import userLevel from '../views/user/user-level'
import levelDetail from '../views/user/level-detail'
import bans from '../views/user/bans'

import clients from '../views/client/clients'
import clientLevel from '../views/client/client-level'
import follows from '../views/client/follows'
import followDetail from '../views/client/follow-detail'
import msgs from '../views/user/msgs'
import sessions from '../views/user/sessions'
import talentpool_list from '../views/user/talent-pool-list'
import talent_deail from '../views/user/talent-deail'


// import service_list from '../views/service/service-list'
// import service_item from '../views/service/service-item'

import district_list from '../views/district/district-list'
import district_item from '../views/district/district-item'

import template from '../views/template'


import sysuser_list from '../views/sysuser/sysuser-list'
import sysuser_item from '../views/sysuser/sysuser-item'

import role_list from '../views/role/role-list'
import role_item from '../views/role/role-item'


import per_list from '../views/per/per-list'
import per_item from '../views/per/per-item'

import clueCount from '../views/clue-count/clue-count'

// import order from '../views/order/list'
import clue from '../views/order/clue'
import need from '../views/order/need'
import trade from '../views/order/trade'
import get from '../views/order/get'

import log from '../views/log/log-list'
import reportlog from '../views/log/report-list'

import login from '../views/login'

import datauser from '../views/data/user-list'

import datademand from '../views/data/demand-list'
import dataincome from '../views/data/income-list'
import datarecord from '../views/data/record-list'

import dataprice from '../views/data/price-list'

import pay from '../views/finance/pay'
import withdrawal from '../views/finance/withdrawal'
import prepay from '../views/finance/prepay'
import prepayDetail from '../views/finance/prepay-detail'
import refund from '../views/finance/refund'
import settlement from '../views/finance/settlement'
import withdraw from '../views/finance/withdraw'
import accounts from '../views/finance/accounts'

import payway from '../views/setting/payway'

import jobs from '../views/job/jobs'
import jobDetail from '../views/job/detail'
import quotes from '../views/job/quotes'

import standardJob from '../views/standardJob/jobs'
import standardJobDetail from '../views/standardJob/detail'


import orders from '../views/order/orders'
import contracts from '../views/order/contracts'

import invoices from '../views/invoice/invoices'
import invoiceDetail from '../views/invoice/detail'

import cates from '../views/cate/cates'
import skills from '../views/cate/skills'
import hotCates from '../views/cate/hots'

import matchConfig from '../views/match/config'
import matchs from '../views/match/matchs'
import matchTool from '../views/match/tool'

import couponActivities from '../views/coupon/activities'
import coupons from '../views/coupon/coupons'
import couponActivity from '../views/coupon/activity'
import couponBuyActivity from '../views/coupon/buyActivity'
import batchAssign from '../views/coupon/assign'
import packageList from '../views/coupon/packageList'

import appeals from '../views/appeal/appeals'
import appeal from '../views/appeal/detail'

import solutions from '../views/solution/list'
import solution from '../views/solution/solution'

import wxPush from '../views/wx/push'

import invites from '../views/invite/invites'

import config from '../views/config/index'

import services from '../views/service/services'

import serviceDetail from '../views/service/detail'
import serviceCheck from '../views/service/checkList'

import search from '../views/search/keywords'

import activities from '../views/activity/list'
import activityEdit from '../views/activity/edit'

import talentActivity from '../views/talentActivity/list'
import talentActivityEdit from '../views/talentActivity/edit'

import ents from '../views/ent/ents'
import member from '../views/ent/member'


import feedbacks from '../views/feedback/feedbacks'
import violations from '../views/user/violations'

import beanLogs from '../views/bean/logs'
import beanConfig from '../views/bean/beanConfig'
import taskManage from '../views/taskManage/index'
import taskOrder from '../views/taskManage/taskOrder'
import taskAppealsDetail from '../views/taskManage/appealsDetail'
import taskAppeals from '../views/taskManage/taskAppeals'
import taskFinal from '../views/taskManage/taskFinal'

import imCallMange from '../views/imCallMange/index'

import setHotLIst from '../views/service/setHotLIst'
import taskPushLog from "../views/taskManage/taskPushLog"


import partyAorder from "../views/prop/partyA/order"
import partyAactivityConfig from "../views/prop/partyA/activityConfig"
import partyAdaily from "../views/prop/partyA/daily"
import partyApropConfig from "../views/prop/partyA/propConfig"



import partyBorder from "../views/prop/partyB/order"
import partyBactivityConfig from "../views/prop/partyB/activityConfig"
import partyBdaily from "../views/prop/partyB/daily"
import partyBpropConfig from "../views/prop/partyB/propConfig"
import propRefund from "../views/prop/refund"




const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        // {
        //     path: '/',
        //     redirect: '/jobs'
        // },

        {
            path: '/datademand',
            name: 'datademand',
            component: datademand
        }, {
            path: '/dataprice',
            name: 'dataprice',
            component: dataprice
        }, {
            path: '/datarecord',
            name: 'datarecord',
            component: datarecord
        }, {
            path: '/dataincome',
            name: 'dataincome',
            component: dataincome
        },

        {
            path: '/user',
            name: 'user-list',
            component: user_list
        },

        {
            path: '/talentpool',
            name: 'talentpool-list',
            component: talentpool_list
        },
        {
            path: '/talent-deail/:id',
            name: 'talent-deail',
            component: talent_deail
        },
        
        {
            path: '/usercheck',
            name: 'user-check',
            component: user_check
        }, {
            path: '/resumeList',
            name: 'resumeList',
            component: resumeList
        },

        {
            path: '/user_item',
            name: 'user-item',
            component: user_item
        },

        {
            path: '/user-detail',
            name: 'user-detail',
            component: userDetail,
        },

        {
            path: '/userlevel',
            name: 'userLevel',
            component: userLevel,
        },
        {
            path: '/clients',
            name: 'clients',
            component: clients,
        },
        {
            path: '/clientlevel',
            name: 'clientLevel',
            component: clientLevel,
        },
        {
            path: '/bans',
            name: 'bans',
            component: bans,
        },
        {
            path: '/msgs',
            name: 'msgs',
            component: msgs,
        },
        {
            path: '/sessions',
            name: 'sessions',
            component: sessions,
        },
        {
            path: '/follows',
            name: 'follows',
            component: follows,
        },
        {
            path: '/follow/detail',
            name: 'followDetail',
            component: followDetail,
        },
        {
            path: '/level-detail',
            name: 'levelDetail',
            component: levelDetail,
        },
        // {
        //     path: '/service/:id/:cityId?',
        //     name: 'service-list',
        //     component: service_list
        // }, {
        //     path: '/service_item',
        //     name: 'service-item',
        //     component: service_item
        // },


        {
            path: '/district/:id',
            name: 'district-list',
            component: district_list
        }, {
            path: '/district_item',
            name: 'district-item',
            component: district_item
        },



        {
            path: '/template',
            name: 'template',
            component: template
        },


        {
            path: '/sysuser',
            name: 'sysuser-list',
            component: sysuser_list
        },

        {
            path: '/role',
            name: 'roles-list',
            component: role_list
        },

        {
            path: '/per',
            name: 'per-list',
            component: per_list
        },
        {
            path: '/clue',
            name: 'clue',
            component: clue
        }, {
            path: '/clue-count',
            name: 'clueCount',
            component: clueCount
        },

        {
            path: '/need',
            name: 'need',
            component: need
        },

        {
            path: '/trade',
            name: 'trade',
            component: trade
        },

        {
            path: '/get',
            name: 'get',
            component: get
        },

        {
            path: '/login',
            name: 'login',
            component: login
        }, {
            path: '/log',
            name: 'log',
            component: log
        }, {
            path: '/reportlog',
            name: 'reportlog',
            component: reportlog
        }, {
            path: '/datauser',
            name: 'datauser',
            component: datauser
        }, {
            path: '/pay',
            name: 'pay',
            component: pay
        },{
            path: '/withdrawal/:role',
            name: 'withdrawal',
            component: withdrawal
        },{
            path: '/prepay',
            name: 'prepay',
            component: prepay
        }, {
            path: '/prepay/detail/:id',
            name: 'prepayDetail',
            component: prepayDetail
        },

        {
            path: '/refund',
            name: 'refund',
            component: refund
        },

        {
            path: '/settlement',
            name: 'settlement',
            component: settlement
        },

        {
            path: '/withdraw',
            name: 'withdraw',
            component: withdraw
        },

        {
            path: '/payway',
            name: 'payway',
            component: payway
        },

        {
            path: '/accounts',
            name: 'accounts',
            component: accounts
        },

        {
            path: '/jobs',
            name: 'jobs',
            component: jobs
        },
        {
            path: '/job/:id',
            name: 'jobDetail',
            component: jobDetail
        },

        {
            path: '/standardJob',
            name: 'standardJob',
            component: standardJob
        },
        {
            path: '/standardJobDetail/edit',
            name: 'standardJobDetail',
            component: standardJobDetail
        },
        {
            path: '/quotes',
            name: 'quotes',
            component: quotes
        },
        {
            path: '/matchs',
            name: 'matchs',
            component: matchs
        },
        {
            path: '/match/config',
            name: 'matchConfig',
            component: matchConfig
        },
        {
            path: '/match/tool',
            name: 'matchTool',
            component: matchTool
        },
        {
            path: '/contracts',
            name: 'contracts',
            component: contracts
        },
        {
            path: '/orders',
            name: 'orders',
            component: orders
        },
        {
            path: '/invoices',
            name: 'invoices',
            component: invoices
        },
        {
            path: '/invoice/detail/:id',
            name: 'invoiceDetail',
            component: invoiceDetail
        },
        {
            path: '/cates',
            name: 'cates',
            component: cates
        },
        {
            path: '/skills',
            name: 'skills',
            component: skills
        },
        {
            path: '/cate/hots',
            name: 'hotCates',
            component: hotCates
        },
        {
            path: '/coupon/activities',
            name: 'couponActivities',
            component: couponActivities
        },
        {
            path: '/coupons',
            name: 'coupons',
            component: coupons
        },
        {
            path: '/coupon/activity',
            name: 'couponActivity',
            component: couponActivity
        },
        {
            path: '/coupon/buyActivity',
            name: 'couponBuyActivity',
            component: couponBuyActivity
        },
        {
            path: '/coupon/packageList',
            name: 'packageList',
            component: packageList
        },
        {
            path: '/coupon/assign/:aid',
            name: 'batchAssign',
            component: batchAssign
        },
        {
            path: '/appeals',
            name: 'appeals',
            component: appeals
        },
        {
            path: '/appeal/detail/:id',
            name: 'appeal',
            component: appeal
        },
        {
            path: '/solutions',
            name: 'solutions',
            component: solutions
        },
        {
            path: '/solution/:id?',
            name: 'solution',
            component: solution
        },
        {
            path: '/wx/push',
            name: 'wxPush',
            component: wxPush
        },
        {
            path: '/invites',
            name: 'invites',
            component: invites
        },
        {
            path: '/config',
            name: 'config',
            component: config
        },
        {
            path: '/services',
            name: 'services',
            component: services
        },
       
        {
            path: '/service/:id?',
            name: 'serviceDetail',
            component: serviceDetail
        },
        {
            path: '/service-check',
            name: 'serviceCheck',
            component: serviceCheck
        },
        {
            path: '/search',
            name: 'search',
            component: search
        },
        {
            path: '/activities',
            name: 'activities',
            component: activities
        },
        {
            path: '/activity/edit',
            name: 'activityEdit',
            component: activityEdit
        },

        {
            path: '/talentActivity',
            name: 'talentActivityList',
            component: talentActivity
        },
        {
            path: '/talentActivity/edit',
            name: 'talentActivityEdit',
            component: talentActivityEdit
        },
        {
            path: '/ents',
            name: 'ents',
            component: ents
        },
        {
            path: '/member',
            name: 'member',
            component: member
        },
        {
            path: '/feedbacks',
            name: 'feedbacks',
            component: feedbacks
        },
        {
            path: '/violations',
            name: 'violations',
            component: violations
        },
        {
            path: '/bean',
            name: 'beanLogs',
            component: beanLogs
        },
        {
            path:'/bean/beanConfig',
            name: 'beanConfig',
            component:beanConfig
        },
        {
            path: '/taskManage/index',
            name: 'taskManage',
            component: taskManage
        },
        {
            path: '/taskManage/taskPushLog/index',
            name: 'taskManage',
            component: taskPushLog
        },
        {
            path: '/taskManage/taskOrder',
            name: 'taskOrder',
            component: taskOrder
        },
        {
            path: '/imCallMange/index',
            name: 'imCallMange',
            component: imCallMange
        },
        {
            path: '/taskManage/appealsDetail',  // 任务申诉详情
            name: 'taskAppealsDetail',
            component: taskAppealsDetail
        },
        {
            path: '/taskManage/taskAppeals',// 任务申诉管理
            name: 'taskAppeals',
            component: taskAppeals
        },
        {
            path: '/taskManage/taskFinal',// 任务结算单
            name: 'taskFinal',
            component: taskFinal
        },
        {
            path: '/setHotLIst',
            name: 'setHotLIst',
            component: setHotLIst
        },
        {
            path: '/prop/partyA/odrer',
            name: 'partyAorder',
            component: partyAorder
        },
        {
            path: '/prop/partyA/activityConfig',
            name: 'partyAactivityConfig',
            component: partyAactivityConfig
        },
        {
            path: '/prop/partyA/daily',
            name: 'partyAdaily',
            component: partyAdaily
        },
        {
            path: '/prop/partyA/propConfig',
            name: 'partyApropConfig',
            component: partyApropConfig
        },

        {
            path: '/prop/partyB/odrer',
            name: 'partyBorder',
            component: partyBorder
        },

        {
            path: '/prop/partyB/activityConfig',
            name: 'partyBactivityConfig',
            component: partyBactivityConfig
        },
        {
            path: '/prop/partyB/daily',
            name: 'partyBdaily',
            component: partyBdaily
        },
        {
            path: '/prop/partyB/propConfig',
            name: 'partyBpropConfig',
            component: partyBpropConfig
        },
        {
            path: '/prop/refund',
            name: 'propRefund',
            component: propRefund
        },
        
        // import setHotLIst from '../views/service/setHotLIst'
    ]
})

router.beforeEach((to, from, next) => {
    const loginPage = to.name == 'login';
    const auth = localStorage.getItem('username');

    if (!auth && !loginPage) {
        next('/login');
    } else {
        next();
    }
});



export default router;



// WEBPACK FOOTER //
// ./src/router/index.js